import css from '@emotion/css';
import styled from '@emotion/styled';
import Loader from 'components/Kizen/Loader';
import { Gradient } from 'components/Kizen/ScrollFadeContainer';
import { CALENDAR_VIEW_OPTIONS } from 'components/Calendar/constants';

export const AddButton = styled.div`
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border-medium);
  box-shadow: 0 1px 3px
    color-mix(in srgb, var(--color-background-black) 5%, transparent);
  background-color: var(--color-background-white);
  &:hover {
    border-color: var(--color-button-secondary-hover);
    &&& > button > i {
      color: var(--color-button-secondary-hover);
    }
  }
  cursor: pointer;

  ${({ view }) =>
    view === CALENDAR_VIEW_OPTIONS.day
      ? css`
          width: 25px;
          height: 30px;
          left: -1px;
          top: 50%;
          transform: translateY(-50%);
          border-radius: 0 15px 15px 0;
          &:hover {
            border-left-color: var(--color-border-medium);
          }
        `
      : css`
          width: 30px;
          height: 25px;
          top: -1px;
          left: 50%;
          transform: translateX(-50%);
          border-radius: 0 0 15px 15px;
          &:hover {
            border-top-color: var(--color-border-medium);
          }
        `}
`;

export const StyledGradient = styled(Gradient)`
  z-index: 1;
`;

export const StyledBroadcastLoader = styled(Loader)`
  margin-top: calc(-10% + 34px);
  position: absolute;
  z-index: 1;
`;
